import React from 'react';
import { Download } from 'lucide-react';
import { motion } from 'framer-motion';
import styles from './ContentHeader.module.css';
import { useState } from 'react';

const ContentHeader = ({ title, url, config }) => {
  const [isActiveApiCall, setIsActiveApiCall] = useState(false);
  
  const handleDownload = async () => {
    if (!url) return;

    setIsActiveApiCall(true)
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Download failed: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = title || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    } finally{
      setIsActiveApiCall(false)
      
    }
  };

  return (
    <motion.div
      className={styles.header}
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className={styles.title}>{title || 'Document'}</div>

      {config?.allow_download && (
        <motion.button
          type="button"
          onClick={handleDownload}
          className={styles.downloadBtn}
          aria-label="Download file"
          title="Download"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 400, damping: 25 }}
          disabled={isActiveApiCall}
        >
          <Download size={16} />
          <span>Download</span>
        </motion.button>
      )}
    </motion.div>
  );
};

export default ContentHeader;